var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"header-slot"},[_vm._t("header")],2),_c('v-divider',{staticClass:"middle-divider"}),_c('div',{staticClass:"content-slot"},[_vm._t("content")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }